<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <router-view></router-view>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50; */
  /* margin-top: 60px; */
}

* {
  margin: 0;
  padding: 0;
}
</style>
